import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { PIN_INBOX_MESSAGE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { PinInboxMessagePayload, PinInboxMessageResponse } from '../types/pinInboxMessage.types';

export const pinInboxMessage = (builder: BuilderType) =>
  builder.mutation<PinInboxMessageResponse, PinInboxMessagePayload>({
    query: (params) => ({
      data: params,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: PIN_INBOX_MESSAGE_URL,
    }),
    transformResponse: (response: GenericApiResponse<PinInboxMessageResponse>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
